// extracted by mini-css-extract-plugin
export var columnList = "_cf-0";